import { Injectable, signal } from '@angular/core';
import {
  SeuCalculationResponseItem,
  SeuInterconnection,
  SeuOffer,
  SeuSavedCrosshairsSetting,
} from '@seu-types';

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  public readonly activeCrosshairSettings = signal<SeuSavedCrosshairsSetting[]>(
    []
  );

  public readonly currentVisibleCalcResponseItem =
    signal<SeuCalculationResponseItem | null>(null);

  public setCurrentVisibleCalcResponseItem(
    calcResponseItems: SeuCalculationResponseItem[],
    offer: SeuOffer,
    interconnection: SeuInterconnection
  ): void {
    const activeGlobalParameterSetId = offer.globalParameters.find(
      (gp) => gp.isDefault
    )?.id;
    const activeInterconnectionId = interconnection.id;
    const activeOperatingConditionId = interconnection.operatingConditions.find(
      (oc) => oc.active
    )?.id;

    if (
      activeGlobalParameterSetId &&
      activeInterconnectionId &&
      activeOperatingConditionId
    ) {
      const resItem =
        calcResponseItems.find(
          (item) =>
            item.globalParameterSetId === activeGlobalParameterSetId &&
            item.interconnectionId === activeInterconnectionId &&
            item.operatingConditionId === activeOperatingConditionId
        ) ?? null;

      this.currentVisibleCalcResponseItem.set(resItem);
    } else {
      this.currentVisibleCalcResponseItem.set(null);
    }
  }
}
